import {
  getNetworkTrackingPropertyGroup,
  getDealerTrackingPropertyGroup,
} from 'app/dealer/utils';
import { trackAction } from 'app/shared/utils/tracking';

import { DealersInsightsLevelActionTypes } from '../../constants';

// NOTE: using static strings so tracking script can pick up this data for the TRACKING doc

/**
 * @typedef {'[DealersInsights Level] SET LEVEL'|'[DealersInsights Level] SET DEALER ID'|'[DealersInsights Level] TOGGLE DEALER MENU'} DealerLocationTrackingAction
 * */

/**
 * @enum {DealerLocationTrackingAction}
 */
export const DEALER_LOCATION_TRACKING_ACTIONS = {
  DEALER_TAB_SELECTED: DealersInsightsLevelActionTypes.SET_LEVEL,
  DEALER_LOCATION_SELECTED: DealersInsightsLevelActionTypes.SET_DEALER_ID,
  DEALER_DROPDOWN_TOGGLED: DealersInsightsLevelActionTypes.TOGGLE_DEALER_MENU,
};

/**
 * Required params to track a filtered dealer location level action
 *
 * @typedef {Object} DealerLevelTrackingParams
 * @property {import('../../../../../../account/Network/reducer').Network} network
 * @property {Object} dealer
 * @property {DealerLocationTrackingAction} action
 */

/**
 * @param {DealerLevelTrackingParams} param0
 * @returns {void}
 */
export const trackFilteredDealerLocation = ({
  network = {},
  dealer = {},
  actionType,
}) => {
  const additionalProperties = {
    ...getNetworkTrackingPropertyGroup(network),
    ...getDealerTrackingPropertyGroup(dealer),
  };

  switch (actionType) {
    case DEALER_LOCATION_TRACKING_ACTIONS.DEALER_TAB_SELECTED:
      trackAction(
        'dashboard_navigation_dealer_location',
        {
          category: 'dealer_portal',
          description: 'user clicks on Dealer location tab to see statistics on dealer location level',
        },
        additionalProperties,
      );
      break;
    case DEALER_LOCATION_TRACKING_ACTIONS.DEALER_LOCATION_SELECTED:
      trackAction(
        'dashboard_dealer_location_dropdown_selection',
        {
          category: 'dealer_portal',
          description: 'user clicks in dealer location drop-down to select a single location',
        },
        additionalProperties,
      );
      break;
    case DEALER_LOCATION_TRACKING_ACTIONS.DEALER_DROPDOWN_TOGGLED:
      trackAction(
        'dashboard_dealer_location_dropdown',
        {
          category: 'dealer_portal',
          description: 'user clicks on dealer location drop-down',
        },
        additionalProperties,
      );
      break;
    default:
      break;
  }
};
